import { render, staticRenderFns } from "./PlantioDesmatamentoRedFlag.vue?vue&type=template&id=f94578ba&lang=pug"
import script from "./PlantioDesmatamentoRedFlag.vue?vue&type=script&lang=js"
export * from "./PlantioDesmatamentoRedFlag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports